<template>
  <span
    v-if="isRendered"
    :class="{
      'typing-text': true,
      'display-none': !isVisible,
    }"
  >
    <span
      v-for="(char, index) in characters"
      :key="index"
      class="char"
      :class="{ 'is-animated': index >= indexAnimationStart }"
      :style="{
        animationDelay: `${Math.max(index - indexAnimationStart, 0) * props.speed}s`,
      }"
    >
      {{ char }}
    </span>
  </span>
</template>

<script lang="ts" setup>
import { watchDeep } from '@vueuse/core';
import { ref, computed, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    isVisible?: boolean;
    text?: string;
    speed?: number;
  }>(),
  {
    isVisible: true,
    text: '',
    speed: 0.025,
  }
);

// TODO: 깜빡임현상&통역방느려지는현상해결목적인임시코드입니다.추후삭제예정입니다.
const isRendered = ref<boolean>(true);

const indexAnimationStart = ref(Number.POSITIVE_INFINITY); // 타이핑 애니메이션 시작지점

// 메세지를 글자별로 나눈 배열
const characters = computed<string[]>(() => {
  // 태국어, 힌디어 포함 모든 언어 지원
  const segmenter = new Intl.Segmenter('und', {
    granularity: 'grapheme',
  });
  return [...segmenter.segment(props.text)].map(({ segment }) => segment);
});

// 추가된 내용은 애니메이션 적용. 기존 내용의 변화는 즉각 적용
watch(
  () => props.text,
  (newVal = '', oldVal = '') => {
    if (newVal.length > oldVal.length) {
      indexAnimationStart.value = oldVal.length;
    } else indexAnimationStart.value = Number.POSITIVE_INFINITY;
  },
  { immediate: true }
);

// TODO: 깜빡임현상&통역방느려지는현상해결목적인임시코드입니다.추후삭제예정입니다.
watchDeep(
  () => props.isVisible,
  (val) => {
    if (!val) {
      setTimeout(() => {
        isRendered.value = false;
      }, 3000);
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.typing-text {
  display: inline;

  &.display-none {
    display: none;
  }
}
span {
  word-break: break-all;
}

.char {
  display: inline;
  opacity: 1;

  &.is-animated {
    opacity: 0;
    animation: fadeIn 0.3s forwards;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
